import { createElement, CSSProperties } from 'react';
import cn from 'classnames';

import icons, { type IconName } from 'assets/inline-svg-icons/icons';

export { type IconName };

interface IconProps {
  className?: string;
  fill?: boolean;
  name: IconName | '';
  style?: CSSProperties;
}

const Icon: React.FC<IconProps> = ({ className, fill, name, style }) => {
  if (!name || !(name in icons)) return null;

  return createElement(icons[name], {
    className: cn('icon', className, { 'icon--use-fill-color': fill }),
    focusable: 'false',
    style
  });
};

Icon.displayName = 'Icon';

export default Icon;
